<adapt-dialog [maxWidth]="850">
    <h3 adapt-dialog-title>{{ title }}</h3>

    @if (culturalIndex) {
        <div adapt-dialog-content>
            <adapt-ci-range [culturalIndex]="culturalIndex"
                            [isDisabled]="true"> </adapt-ci-range>
            <div class="cultural-index-comment">
                <p>
                    <strong>My orbit is {{ getDirectionState(culturalIndex.direction) }}. </strong>
                </p>
                @if (culturalIndex.notes) {
                    <div [froalaView]="culturalIndex.notes"></div>
                }
            </div>
            <adapt-cultural-measurement-meta [culturalEntity]="culturalIndex"
                                             [showCulturalLeaderData]="true"> </adapt-cultural-measurement-meta>
        </div>
    }

    <div adapt-dialog-footer
         class="ms-auto">
        @if (hasEditPermission) {
            <button adaptButton="edit"
                    (click)="editCulturalIndex()"></button>
        }
        @if (hasEditPermission) {
            <button adaptButton="delete"
                    (click)="deleteCulturalIndex()"></button>
        }
        <button class="btn btn-primary"
                adaptButtonIcon="fa"
                (click)="resolve(culturalIndex!)">OK</button>
    </div>
</adapt-dialog>
